module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_short_front_shadow.2993fed9.png";